<template>
  <!-- :class="`${workpackage.color} ${!workpackage.color.includes('lighten') || !workpackage.color.includes('darken')?'lighten-1':''}`" -->
  <div :style="`position: relative; height: 100%; background-color: ${workpackage_bg_hex}; fill: ${workpackage_fg_hex}`">
    <WorkPackageHead
      v-if="location !== 'ProjectWallet'"
      :head="{
          token: workpackage.token,
          name: workpackage.name,
          icon: workpackage.icon,
          area: backlog ? wbline.name : taktarea.name,
          status_done_count: $store.state.Ultra.status_array.findIndex(status => status.name === workpackage.status),
          status_is_stop: workpackage.stop_status,
        }"
      :background_color="workpackage_bg_hex"
      :foreground_color="workpackage_fg_hex"
      @selectStatus="
        updateUObject({
          url: workpackage_url,
          url_suffix: $event.tooltip.toLowerCase() !== 'stop' ? '/status' : '/stopstatus',
          update: $event.tooltip.toLowerCase() !== 'stop' ?
            { status: workpackage.status !== $event.tooltip.toLowerCase() ? $event.tooltip.toLowerCase() : 'none' }
            :
            { stop_status: workpackage.stop_status !== 'none' ? 'none' : 'stop' }
        })"
      @selectStopStatus="
        updateUObject({
          url: workpackage_url,
          url_suffix: '/stopstatus',
          update: { stop_status: workpackage.stop_status !== 'none' ? 'none' : 'stop' }
        }).then(() => {
          if ($event !== ''){
            if(backlog){
              createLogListComment({
                backlog: true,
                project_id: project_id,
                wbgroup_id: wbgroup_id,
                wbline_id: wbline_id,
                workpackage_id: workpackage.id,
                data: {
                  comment: $event,
                },
              })
            }else{
              createLogListComment({
                project_id: project_id,
                train_id: train_id,
                taktarea_id: taktarea_id,
                twaggon_id: twaggon_id,
                workpackage_id: workpackage.id,
                data: {
                  comment: $event,
                },
              })
            }
          }
        })"
      @clickHeader="
        location.includes('HistProjectTaktPlan')
          ? $router.push({ name: 'HistProjectTaktPlan', params: { nav_back: $route.params.nav_back} })
          : $router.push({ name: 'ProjectTaktPlan', params: { nav_back: $route.params.nav_back} })"
      :readonly="location.includes('HistProjectTaktPlan')"
    />
    <!-- style="z-index: 20" -->
    <div
      :class="`workpackage-rework`"
      :style="location === 'ProjectWallet' ? 'height: 100%' : (isMobile ? `height: calc(${mobile_height}px - 70px - 35px - 6px)` : '')"
    >
      <div class="workpackage-content-container" id="ultra-container"
        :style="location === 'ProjectWallet' || isMobile ? 'width: 100%; height: calc(100% + 5px)' : ''">
        <!-- TODO: Scrollbar must get 'position: absolute', also, there must be space to the right -->
        <!-- header -->
        <div
          :style="`position: relative; display: flex; align-items: center; justify-content: space-between; height: 40px; color: ${workpackage.textcolor};`"
          v-if="backlog"
        >
          <div>Date: {{
            workpackage.position !== -1 ? `${getWBWorkpackageDate(workpackage, project_id).start} -
                      ${getWBWorkpackageDate(workpackage, project_id).end}` : 'no date set'
          }}</div>
          <v-btn v-if="isEditMode" icon small @click="show_date_picker = true"
            :color="workpackage.textcolor"><v-icon>today</v-icon></v-btn>
          <BacklogDatePicker
            v-if="show_date_picker"
            :date="getWBWorkpackageDate(workpackage, project_id)"
            :wbworkpackage_position="workpackage.position"
            @clickOutside="show_date_picker = false"
            @clickClose="show_date_picker = false"
            @updatePosition="updateUObject({
              url: workpackage_url,
              update: {
                position: $event
              }
            })"
            @updateLength="updateUObject({
              url: workpackage_url,
              update: {
                length: $event
              }
            })"
            @clickRemove="updateUObject({
              url: workpackage_url,
              update: {
                position: -1,
                length: 1,
              }
            })"
          />
        </div>
        <!-- DESCRIPTION -->
        <CollapsableCategory value="Description" :color="workpackage_fg_hex">
          <template #content="{ is_collapsed, }">
            <TransitionAccordion>
              <div v-if="!is_collapsed && isEditMode">
                <TText :text="workpackage.name" small :font_weight="500" :color="workpackage_fg_hex" />
                <TText :text="backlog ? wbline.name : taktarea.name" small :font_weight="500" :color="workpackage_fg_hex" />
                <TextArea :value="workpackage.description" :label="$t('WorkpackageRework.Info.Description')"
                  :placeholder="`Describe the WORK.package`" :max_char_count="isEditMode ? 500 : ''" :height="170"
                  :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex"
                  :is_disabled="!isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: 'Work Packages', twp: workpackage.id })"
                  @change="
                backlog ?
                  updateUObject({
                    url: workpackage_url,
                    update: {
                      description: $event
                    }
                  })
                  :
                  requestSnackbarUpdate({
                    url: workpackage_url,
                    update: {
                      description: $event
                    },
                    selector: 'target',
                  }).then((payload) => {
                    updateUObject(payload);
                  })" />
              </div>
            </TransitionAccordion>
            <TransitionAccordion>
              <div v-if="!is_collapsed && !isEditMode">
                <TText :text="workpackage.name" small :font_weight="500" :color="workpackage_fg_hex" />
                <TText :text="backlog ? wbline.name : taktarea.name" small :font_weight="500" :color="workpackage_fg_hex" />
                <TText :text="workpackage.description" small :color="workpackage_fg_hex" />
              </div>
            </TransitionAccordion>
          </template>
        </CollapsableCategory>

        <!-- STEP LIST -->
        <CollapsableCategory value="Steps" :color="workpackage_fg_hex">
          <template #content="{ is_collapsed }">
            <WorkPackageStepCategoryList :items="[
              {
                step_type: 'Logistic',
                is_disabled: !hasPermission('TLogisticStep READ'),
                progress: calcStepProgress('logistic')
              },
              {
                step_type: 'Design',
                is_disabled: !hasPermission('TDesignStep READ'),
                progress: calcStepProgress('design')
              },
              {
                step_type: 'Work',
                is_disabled: !hasPermission('TWorkStep READ'),
                progress: calcStepProgress('work')
              },
              {
                step_type: 'Quality',
                is_disabled: !hasPermission('TQualityStep READ'),
                progress: calcStepProgress('quality')
              },
              {
                step_type: 'Defect',
                is_disabled: !hasPermission('TDefectStep READ'),
                progress: calcStepProgress('defect')
              },
              {
                step_type: 'Handover',
                is_disabled: !hasPermission('THandoverStep READ'),
                progress: calcStepProgress('handover')
              },
              {
                step_type: 'Material',
                is_disabled: !hasPermission('TMaterialStep READ'),
                progress: calcStepProgress('material')
              },
              {
                icon: 'mdi-crane',
                step_type: 'Machine',
                is_disabled: !hasPermission('TMachineStep READ'),
                progress: calcStepProgress('machine')
              },
              /* {
                icon: 'mdi-hammer-screwdriver',
                step_type: 'Tool',
                progress: { done_count: 0, task_count: 0},
              },
              {
                icon: 'mdi-signal-variant',
                step_type: 'Sensor',
                progress: { done_count: 0, task_count: 0},
              },
              {
                icon: 'mdi-robot-happy-outline',
                step_type: 'Robotic',
                progress: { done_count: 0, task_count: 0},
              }, */
            ]" :has_lines="true" :key="`additionalinformation${update_additional_info}`" :is_collapsed="is_collapsed"
              :background_color="workpackage_bg_hex" :foreground_color="workpackage_fg_hex" :items_per_row="5"
              @stepsClick="$router.push({ name: `${location}WorkPackage${$event}Steps`, params: { nav_back: $route.params.nav_back} })" />
          </template>
        </CollapsableCategory>


        <!-- TIME RECORD -->
        <CollapsableCategory
          v-if="!location.includes('HistProjectTaktPlan')"
          value="Time_Record"
          :color="workpackage_fg_hex">
          <template #content="{ is_collapsed }">
            <!-- ⌀∑ -->
            <TimeRecord
              v-if="!location.includes('HistProjectTaktPlan')"
              :equations="[
              {
                description: 'On Site',
                id: 'On Site',
                description_suffix: hasCalendar(project_id) ? `(${selected_day === 'TAKT' ? `${$t('WorkpackageRework.Info.TimeRecord.TAKT')}` : daily_report_days.find(day => day.description === selected_day).takt_date})` : '(Missing Calendar!)',
                /* label (string), label_size (number), icon (string), text (string), operator (string) */
                elements: [
                  {
                    label: 'Time Effort', id: 'Time Effort', label_suffix: selected_day === 'TAKT' ? '∑' : '', icon: 'speedometer', value: selected_report.time_effort, unit: 'Mh',
                    input_type: 'number', input_mode: 'decimal', operator: '',
                    is_disabled: true
                  },
                  { icon: '', value: '', operator: selected_day === 'TAKT' ? ' ' : '/' },
                  {
                    label: 'Manpower', id: 'Manpower', label_suffix: selected_day === 'TAKT' ? '⌀' : '', icon: 'person-standing', value: selected_report.manpower, unit: 'M',
                    input_type: 'number', input_mode: 'decimal', operator: '',
                    is_disabled: hasCalendar(project_id) && hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: 'Work Packages', twp: workpackage.id }) ? false : true
                  },
                  { icon: '', value: '', operator: selected_day === 'TAKT' ? ' ' : '=' },
                  {
                    label: 'Duration', id: 'Duration', label_suffix: selected_day === 'TAKT' ? '∑' : '', icon: 'stopwatch', value: selected_report.duration, unit: 'h',
                    input_type: 'number', input_mode: 'decimal', operator: '',
                    is_disabled: hasCalendar(project_id) && hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: 'Work Packages', twp: workpackage.id }) ? false : true
                  },
                ],
              },
              {
                description: 'Plan',
                id: 'Plan',
                description_suffix: `(${$t('WorkpackageRework.Info.TimeRecord.TAKT')})`,
                /* label (string), label_size (number), icon (string), value (string), operator (string) */
                elements: [
                  { label: 'Time Effort', id: 'Time Effort', icon: 'speedometer', value: workpackage.time_effort_source === 'time_effort_planned' ? workpackage.time_effort_planned : (workpackage[`${prefix}worksteps`].length === 0 ? workpackage.time_effort_steps : calcAllWorkStepsTotal({ workpackage, prefix: `${histprefix}${prefix}` }).value), unit: 'Mh', input_type: 'number', operator: '', is_disabled: true },
                  { icon: '', value: '', operator: '/' },
                  { label: 'Manpower', id: 'Manpower', icon: 'person-standing', value: workpackage.manpower_planned, unit: 'M', input_type: 'number', input_mode: 'decimal', operator: '', is_disabled: !isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: 'Work Packages', twp: workpackage.id }) },
                  { icon: '', value: '', operator: '=' },
                  { label: 'Duration', id: 'Duration', icon: 'stopwatch', value: workpackage.manpower_planned > 0 ? (Math.round(((workpackage.time_effort_source === 'time_effort_planned' ? workpackage.time_effort_planned : (workpackage[`${prefix}worksteps`].length === 0 ? workpackage.time_effort_steps : calcAllWorkStepsTotal({ workpackage, prefix: `${histprefix}${prefix}` }).value)) / workpackage.manpower_planned) * 100) / 100) : 0, unit: 'h', input_type: 'number', operator: '', is_disabled: true },
                ],
              },
              {
                description: 'Time Effort Plan Source',
                id: 'Time Effort Plan Source',
                /* label (string), label_size (number), icon (string), value (string), operator (string) */
                elements: [
                  { label: 'WORK.steps', id: 'Worksteps', icon: 'speedometer', value: workpackage[`${prefix}worksteps`].length === 0 ? workpackage.time_effort_steps : calcAllWorkStepsTotal({ workpackage, prefix: `${histprefix}${prefix}` }).value, unit: 'Mh', input_type: 'number', operator: '', is_disabled: true },
                  { label: 'SourceButton', id: 'SourceButton', button: true, is_selected: workpackage.time_effort_source === 'time_effort_steps', icon: workpackage.time_effort_source === 'time_effort_steps' ? 'check' : false, value: 'time_effort_steps', width: '26', is_disabled: !isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: 'Work Packages', twp: workpackage.id }) },
                  { label: 'SourceButton', id: 'SourceButton', button: true, is_selected: workpackage.time_effort_source === 'time_effort_planned', icon: workpackage.time_effort_source === 'time_effort_planned' ? 'check' : false, value: 'time_effort_planned', width: '26', is_disabled: !isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: 'Work Packages', twp: workpackage.id }) },
                  { label: 'WORK.package', id: 'WORKpackage', icon: 'speedometer', value: workpackage.time_effort_planned, unit: 'Mh', input_type: 'number', input_mode: 'decimal', operator: '', is_disabled: !isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: 'Work Packages', twp: workpackage.id }) },
                ],
              },
            ]"
            :time_squares="daily_report_days"
            :selected_day="selected_day"
            :is_collapsed="is_collapsed"
            :collapsed_equations="[
              {
                description: 'On Site',
                id: 'On Site',
                description_suffix: hasCalendar(project_id) ? `(${selected_day === 'TAKT' ? `${$t('WorkpackageRework.Info.TimeRecord.TAKT')}` : daily_report_days.find(day => day.description === selected_day).takt_date})` : '(Missing Calendar!)',
                /* label (string), label_size (number), icon (string), text (string), operator (string) */
                elements: [
                  { label: 'SourceButton', id: 'SourceButton', description: selected_day, button: true, is_selected: true, width: '42', height: '42', not_clickable: true },
                  { label: 'Manpower', id: 'Manpower', icon: 'person-standing', value: selected_report.manpower, unit: 'M', input_type: 'number', input_mode: 'decimal', operator: '', is_disabled: hasCalendar(project_id) ? false : true },
                  { label: 'Duration', id: 'Duration', icon: 'stopwatch', value: selected_report.duration, unit: 'h', input_type: 'number', input_mode: 'decimal', operator: '', is_disabled: hasCalendar(project_id) ? false : true },
                ],
              },
              {
                description: 'Plan',
                id: 'Plan',
                description_suffix: `(${$t('WorkpackageRework.Info.TimeRecord.TAKT')})`,
                /* label (string), label_size (number), icon (string), value (string), operator (string) */
                elements: [
                  { label: 'Manpower', id: 'Manpower', icon: 'person-standing', value: workpackage.manpower_planned, unit: 'M', input_type: 'number', operator: '', is_disabled: !isEditMode || !hasProjectPermissionForTWP({ project_id: project_id, action: 'Update', entity: 'Work Packages', twp: workpackage.id }) },
                  { label: 'Duration', id: 'Duration', icon: 'stopwatch', value: workpackage.manpower_planned > 0 ? (Math.round(((workpackage.time_effort_source === 'time_effort_planned' ? workpackage.time_effort_planned : (workpackage[`${prefix}worksteps`].length === 0 ? workpackage.time_effort_steps : calcAllWorkStepsTotal({ workpackage, prefix: `${histprefix}${prefix}` }).value)) / workpackage.manpower_planned) * 100) / 100) : 0, unit: 'h', input_type: 'number', operator: '', is_disabled: true },
                ],
              },
            ]"
            :items_per_row="5"
            :background_color="workpackage_bg_hex"
            :foreground_color="workpackage_fg_hex"
            @clickDay="selected_day = $event"
            @changeManpowerPlan="
              backlog ?
                updateUObject({
                  url: workpackage_url,
                  update: {
                    manpower_planned: parseFloat($event)
                  }
                })
                :
                requestSnackbarUpdate({
                  url: workpackage_url,
                  update: {
                    manpower_planned: parseFloat($event)
                  },
                  selector: 'target'
                }).then((payload) => {
                  updateUObject(payload);
                })"
            @changeWORKpackageTimeEffortPlanSource="
              backlog ?
                updateUObject({
                  url: workpackage_url,
                  update: {
                    time_effort_planned: parseFloat($event)
                  }
                })
                :
                requestSnackbarUpdate({
                  url: workpackage_url,
                  update: {
                    time_effort_planned: parseFloat($event)
                  },
                  selector: 'target'
                }).then((payload) => {
                  updateUObject(payload);
                })"
            @changeManpowerOnSite="changeDailyReport({ prop: 'manpower', value: parseFloat($event) })"
            @changeDurationOnSite="changeDailyReport({ prop: 'duration', value: parseFloat($event) })"
            @clickSourceButtonTimeEffortPlanSource="
              backlog ?
                updateUObject({
                  url: workpackage_url,
                  update: {
                    time_effort_source: $event
                  }
                })
                :
                requestSnackbarUpdate({
                  url: workpackage_url,
                  update: {
                    time_effort_source: $event
                  },
                  selector: 'target'
                }).then((payload) => {
                  updateUObject(payload);
                })"
            />
          </template>
        </CollapsableCategory>

        <!-- WIDGETS -->
        <CollapsableCategory
          v-if="!location.includes('HistProjectTaktPlan')"
          value="Extras"
          :color="workpackage_fg_hex"
          :is_disabled="true">
          <template #content>
            <WorkPackageWidgetList
              :widgets="prepared_widgets"
              :items_per_row="5"
              :background_color="workpackage_bg_hex"
              :foreground_color="workpackage_fg_hex"
              :is_small_icons="true" @setActive="$router.push({
                name: $route.name.includes($event.route_name)
                  ? `${location}WorkPackageInfo`
                  : `${location}${$event.route_name}`,
                params: { nav_back: $route.params.nav_back },
              })"
            />
          </template>
        </CollapsableCategory>

        <div @click="changeWorkPackageFontColor()" :style="`background-color: ${opposite_text_color}`" class="workpackage-fontcolor-corner"></div>

      </div>
      <transition :name="location === 'ProjectWallet' || isMobile ? 'subage-slide-in' : 'appear'">
        <router-view style="z-index: 10" />
      </transition>
    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import { mapGetters, mapActions } from 'vuex';

import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'
import { BacklogMixin } from '@/mixins/Backlog.mixin.js'

import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TextArea from '@/components/WorkPackageWIP/TextArea.component.vue';
import WorkPackageStepCategoryList from '@/modules/WorkPackageWIP/WorkPackageStepCategoryList.module.vue';
import TimeRecord from '@/modules/WorkPackageWIP/TimeRecord.module.vue';
import WorkPackageWidgetList from '@/modules/WorkPackageWIP/WorkPackageWidgetList.module.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';
import WorkPackageHead from '@/modules/WorkPackageWIP/WorkPackageHead.module.vue';
import BacklogDatePicker from '@/components/TaktPlanBacklogs/BacklogDatePicker.component.vue';

// import { mapState } from 'vuex';

export default {
  components: {
    CollapsableCategory,
    TText,
    WorkPackageStepCategoryList,
    TimeRecord,
    WorkPackageWidgetList,
    TransitionAccordion,
    WorkPackageHead,
    TextArea,
    BacklogDatePicker
  },
  mixins: [
    WorkPackageReworkMixin,
    BacklogMixin
  ],
  props: ['location', 'prefix', 'backlog'],
  data: () => ({
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Mi tempus imperdiet nulla malesuada pellentesque elit eget. Massa tincidunt nunc pulvinar sapien. Faucibus vitae aliquet nec ullamcorper sit.',
    bg: '#FFC900',
    fg: '#000',
    selected_day: 'Mo',
    update_additional_info: 0,
    // bg: '#330011',
    // fg: '#FFF',
    color_update_key: 0,
    show_date_picker: false,
    widgets: [
      { icon: 'camera-simple', text: 'Camera', route_name: 'WorkPackageCamera' },
      { icon: 'image', text: 'Images', route_name: 'WorkPackageImages' },
      { icon: 'qr-code', text: 'QR-Codes', route_name: 'WorkPackageQRCodes' },
      { icon: 'person', text: 'Contacts', route_name: 'WorkPackageContacts' },
      { icon: 'money-bill', text: 'Costs', route_name: 'WorkPackageCosts' },
      { icon: 'pencil', text: 'Log', route_name: 'WorkPackageLogList' },
      { icon: 'info', text: 'Info', route_name: 'WorkPackageAdditionalInformation' },
      { icon: 'steering-wheel', text: 'Autopilots', route_name: 'WorkPackageAutopilots' },
      { icon: 'cube', text: 'Elements', route_name: 'WorkPackageElements' },

      /* NOTE: icons in commented widgets are depricated */
      /* { icon: 'file_present', text: 'Files', route_name: 'WorkPackageFiles' }, */
      /* { icon: 'mdi-cash', text: 'Pay' }, */ /* context sensitive */
      /* { icon: 'mdi-cube-outline', text: '3D', route_name: 'WorkPackage3D' }, */
      /* { icon: 'mdi-email-outline', text: 'Shouts', is_badge: true, badge_info: 2, route_name: 'WorkPackageShouts' }, */
      /* { icon: 'mdi-format-list-bulleted', text: 'Log List' }, */
      /* { icon: 'mdi-coffee-outline', text: 'AI', route_name: 'WorkPackageAI' }, */
      /* { icon: 'mdi-molecule-co2', text: 'Emissions' }, */
      /* { icon: 'mdi-rhombus-outline', text: 'Milestones', route_name: 'WorkPackageAI' }, */
    ]
  }),
  created() {
    let self = this;
    this.setValue({key: 'font_color_settings', value: { source: 'workpackage' }});
    if (!this.location.includes('HistProjectTaktPlan')) {
      this.initializeSelectedDay();
    }
    store.dispatch('UltraDev/updateUDObject', {
      url: this.workpackage_url,
      update: { is_open: true }
    });
    // console.log('testsetest', this.workpackage_url);
    this.requestUObject({
      url: this.workpackage_url,
      url_suffix: '/additionalinformation'
    }).then(() => {
      self.update_additional_info++;
    });
  },
  watch: {
    workpackage_id(val, old_val) {
      this.setValue({key: 'font_color_settings', value: { source: 'workpackage' }});
      if (!this.location.includes('HistProjectTaktPlan')) {
        this.initializeSelectedDay();
      }
      let update_url_val = JSON.parse(JSON.stringify(this.workpackage_url));
      let update_url_old_val = JSON.parse(JSON.stringify(this.workpackage_url));

      update_url_val[update_url_val.length - 1][`${this.histprefix}${this.prefix}workpackages`] = val;
      update_url_old_val[update_url_old_val.length - 1][`${this.histprefix}${this.prefix}workpackages`] = old_val;

      store.dispatch('UltraDev/updateUDObject', {
        url: update_url_val,
        update: { is_open: true }
      });
      store.dispatch('UltraDev/updateUDObject', {
        url: update_url_old_val,
        update: { is_open: false }
      });

      this.requestUObject({
        url: update_url_val,
        url_suffix: '/additionalinformation'
      }).then(() => {
        self.update_additional_info++;
      });
    }

  },
  beforeRouteLeave(to, from, next) {
    store.dispatch('UltraDev/updateUDObject', {
      url: this.workpackage_url,
      update: { is_open: false }
    });
    next();
  },
  computed: {
    ...mapGetters('Ultra', [
      'getUObjectsFiltered',
      'getUObjects'
    ]),
    ...mapGetters('Auth', [
      'hasPermission'
    ]),
    ...mapGetters('Project', [
      'getOwnTWorkPackages',
      'hasProjectPermission',
      'hasProjectPermissionForTWP',
    ]),
    ...mapGetters('ProjectCalendar', [
      'getCalendar',
      'getWeekDaysSorted',
      'hasCalendar',
    ]),
    histprefix() {
      if (this.location.includes('HistProjectTaktPlan')) {
        return 'hist';
      }
      return '';
    },
    taktarea() {
      return this.$store.state.Ultra[`${this.histprefix}taktareas`][this.taktarea_id];
    },
    wbline() {
      return this.$store.state.Ultra[`${this.histprefix}wblines`][this.wbline_id];
    },
    mobile_height() {
      return window.innerHeight;
    },
    daily_report_days() {
      if (this.location.includes('HistProjectTaktPlan')) {
        return [];
      }
      let days = [];
      let week_days_sorted = this.getWeekDaysSorted(this.project_id);
      week_days_sorted.forEach(day => {
        days.push({ description: day, is_disabled: true, takt_date: '' })
      });
      days = days.concat([
        { is_invisible: true, is_disabled: true },
        { is_invisible: true, is_disabled: true },
        { description: 'TAKT', takt_date: '', is_disabled: this.backlog }
      ]);
      if (this.hasCalendar(this.project_id)) {
        let index = 0;
        if(this.backlog){
          index = this.workpackage.position;
        } else {
          index = this.$store.state.Ultra.trains[this.train_id].train_start + this.taktarea.taktarea_start + this.taktarea.twaggons.indexOf(parseInt(this.twaggon_id));
        }
        let calendar = this.getCalendar(this.project_id);
        if (index !== -1) {
          calendar.takt_times[index].dates.forEach(date => {
            let name = this.$store.state.Ultra.week_days[date.getDay()];
            let day = days.find(day => day.description === name);
            day.is_disabled = false
            day.takt_date = date.toISOString().substring(0, 10);
          });
        }
      }
      return days;
    },
    selected_report() {
      if (this.selected_day !== 'TAKT') {
        let selected_takt_date = this.daily_report_days.find(day => day.description === this.selected_day).takt_date;
        let reports = JSON.parse(JSON.stringify(this.getUObjectsFiltered({ type: 'dailyreports', ids: this.workpackage.dailyreports, search: { date: selected_takt_date } })));
        if (reports.length !== 0) {
          reports[0].time_effort = reports[0].manpower * reports[0].duration;
          return reports[0];
        } else {
          // no record created
          return {
            manpower: 0,
            duration: 0,
            time_effort: 0,
            date: selected_takt_date,
            create: true,
          };
        }
      } else {
        let takt_report = {
          manpower: 0,
          duration: 0,
          time_effort: 0,
          date: 'TAKT'
        }
        let dailyreports = this.getUObjects({ type: 'dailyreports', ids: this.workpackage.dailyreports });
        dailyreports.forEach(report => {
          takt_report.manpower += report.manpower;
          takt_report.duration += report.duration;
          takt_report.time_effort += (report.manpower * report.duration);
        });
        if (dailyreports.length !== 0) {
          takt_report.manpower = Math.round((takt_report.manpower / dailyreports.length) * 100) / 100;
        } else {
          takt_report.manpower = 0;
        }
        return takt_report;
      }
    },
    opposite_text_color() {
      if (this.workpackage_fg_hex === '#000') {
        return '#fff';
      } else {
        return '#000';
      }
    },
    prepared_widgets(){
      let mywidgets = JSON.parse(JSON.stringify(this.widgets));
      mywidgets.forEach(widget => {

        switch (widget.route_name) {
          case 'WorkPackageCamera':
          case 'WorkPackageImages':
          case 'WorkPackageQRCodes':
          case 'WorkPackageContacts':
          case 'WorkPackageCosts':
          case 'WorkPackageLogList':
          case 'WorkPackageAdditionalInformation':
            widget.disabled = false;
            widget.tooltip = widget.text;
            break;
          case 'WorkPackageAutopilots':
            widget.disabled = !this.hasProjectPermissionForTWP({project_id: this.project_id, action: 'Read', entity: `AutopilotIssues`, twp: this.workpackage.id});
            widget.tooltip = this.getProjectTooltip({project_id: this.project_id, action: 'Read', entity: `AutopilotIssues`, twp: this.workpackage.id});
            break;
          case 'WorkPackageElements':
            widget.disabled = !this.hasProjectPermissionForTWP({project_id: this.project_id, action: 'Read', entity: `Elements`, twp: this.workpackage.id});
            widget.tooltip = this.getProjectTooltip({project_id: this.project_id, action: 'Read', entity: `Elements`, twp: this.workpackage.id});
            break;
        }
      });
      return mywidgets;

    },
  },
  methods: {
    ...mapActions('Ultra', [
      'updateUObject',
      'requestUObject',
    ]),
    ...mapActions('View', [
      'setValue'
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbarUpdate'
    ]),
    ...mapActions('UltraDev', [
      'updateUDObject',
    ]),
    ...mapActions('WorkPackageLogList', [
      'createLogListComment',
    ]),
    changeWorkPackageFontColor(){
        this.setValue({ key: 'font_color_settings', value: {
          color: this.opposite_text_color,
          source: 'user'
        }});
        this.color_update_key++;
    },
    calcStepProgress(step_type) {
      return {
        done_count: this.workpackage[`${this.histprefix}${this.prefix}${step_type}steps`].length !== 0 ?
          this.getUObjectsFiltered({ type: `${this.histprefix}${this.prefix}${step_type}steps`, ids: this.workpackage[`${this.histprefix}${this.prefix}${step_type}steps`], filter: { done: true } }).length
          : (
            this.workpackage[`${this.prefix}${step_type}steps_done_count`] ?
              this.workpackage[`${this.prefix}${step_type}steps_done_count`]
              :
              0),
        task_count: this.workpackage[`${this.histprefix}${this.prefix}${step_type}steps`].length === 0 ?
          this.workpackage[`${this.prefix}${step_type}_step_count`]
          :
          this.workpackage[`${this.histprefix}${this.prefix}${step_type}steps`].length
      };
    },
    handleCheckBoxClicked(origin) {
      let tmp = this.checkboxes.find(element => element.id == origin);
      tmp.is_checked = !tmp.is_checked;
    },
    initializeSelectedDay() {
      if (this.hasCalendar(this.project_id) && !this.backlog) {
        let index = this.$store.state.Ultra.trains[this.train_id].train_start + this.taktarea.taktarea_start + this.taktarea.twaggons.indexOf(parseInt(this.twaggon_id));
        if (index !== -1) {
          let today = new Date().toISOString().substring(0, 10);
          let day = this.daily_report_days.find(day => day.takt_date === today);
          if (day) {
            this.selected_day = day.description;
          } else {
            this.selected_day = this.daily_report_days.filter(day => !day.is_disabled && day.description !== 'TAKT')[0].description;
          }
        }
      }
    },
    changeDailyReport(payload) {
      if (this.selected_report.create) {
        let report = {
          manpower: 0,
          duration: 0,
          date: this.selected_report.date
        }
        report[payload.prop] = payload.value;

        let url;
        if (this.backlog){
          url = [
            { projects: this.project_id },
            { wbgroups: this.wbgroup_id },
            { wblines: this.wbline_id },
            { wbworkpackages: this.workpackage_id },
            { dailyreports: '' },
            { showWithEntitiesNormalized: '' }
          ]
        } else {
          url = [
            { projects: this.project_id },
            { trains: this.train_id },
            { taktareas: this.taktarea_id },
            { twaggons: this.twaggon_id },
            { tworkpackages: this.workpackage_id },
            { dailyreports: '' },
            { showWithEntitiesNormalized: '' }
          ];
        }
        console.log('url', url);
        this.createUObject({
          url: url,
          u_object: report
        })
      } else if (this.selected_report.date !== 'TAKT') {
        let url;
        if (this.backlog){
          url = [
            { projects: this.project_id },
            { wbgroups: this.wbgroup_id },
            { wblines: this.wbline_id },
            { wbworkpackages: this.workpackage_id },
            { dailyreports: this.selected_report.id }
          ]
        } else {
          url = [
            { projects: this.project_id },
            { trains: this.train_id },
            { taktareas: this.taktarea_id },
            { twaggons: this.twaggon_id },
            { tworkpackages: this.workpackage_id },
            { dailyreports: this.selected_report.id }
          ];
        }
        console.log('url 2', url);
        this.updateUObject({
          url: url,
          update: {
            [payload.prop]: payload.value
          }
        })
      } else {
        let dailyreports = this.getUObjects({ type: 'dailyreports', ids: this.workpackage.dailyreports });
        let daily_report_days_filtered = JSON.parse(JSON.stringify(this.daily_report_days.filter(day => !day.is_disabled && day.description !== 'TAKT')));
        daily_report_days_filtered.forEach(day => {
          let daily_report = dailyreports.find(report => report.date.includes(day.takt_date));
          if (daily_report) {
            this.updateUObject({
              url: [
                { projects: this.project_id },
                { trains: this.train_id },
                { taktareas: this.taktarea_id },
                { twaggons: this.twaggon_id },
                { tworkpackages: this.workpackage_id },
                { dailyreports: daily_report.id }
              ],
              update: {
                [payload.prop]: payload.prop === 'duration' ? (payload.value / daily_report_days_filtered.length) : payload.value
              }
            })
          } else {
            let report = {
              manpower: 0,
              duration: 0,
              date: day.takt_date
            }
            report[payload.prop] = payload.prop === 'duration' ? (payload.value / daily_report_days_filtered.length) : payload.value;
            this.createUObject({
              url: [
                { projects: this.project_id },
                { trains: this.train_id },
                { taktareas: this.taktarea_id },
                { twaggons: this.twaggon_id },
                { tworkpackages: this.workpackage_id },
                { dailyreports: '' },
                { showWithEntitiesNormalized: '' }
              ],
              u_object: report
            })
          }
        });
      }
    },
  },
}
</script>
<style>
.workpackage-rework {
  position: relative;
  display: flex;
  flex-shrink: 0;
  height: calc(100% - 70px);
  width: 100%;
  /* background-color: blue; */
  transition: border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
  z-index: 10;
}

.workpackage-content-container {
  /* position: absolute;
    max-width: 320px;
    left: 15px; */
  position: relative;
  width: 320px;
  overflow: auto;
  flex-shrink: 0;
  /* width: 320px; */
  /* padding: 5px 10px 10px 10px; */
  padding: 5px 4px 10px 14px;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}

.work-package-image-detail-new-image {
  display: flex;
  width: 100%;
  /* justify-content: space-between; */
  justify-content: center;
  grid-gap: 24px;
}

.appear-enter-active,
.appear-leave-active {
  transition: all 0.5s ease-in-out;
}

.appear-enter,
.appear-leave-to {
  opacity: 0;
}

.subage-slide-in-enter-active,
.subage-slide-in-leave-active {
  transition: all 0.25s ease-in-out;
}

.subage-slide-in-enter,
.subage-slide-in-leave-to {
  transform: translateX(100%);
}

.workpackage-fontcolor-corner {
  height: 10px;
  width: 10px;
  position: absolute;
  left: 0px;
  bottom: 0px;
  cursor: pointer;
}
</style>
